import { render, staticRenderFns } from "./ChangeDetailsDialog.vue?vue&type=template&id=61b7ae53&"
import script from "./ChangeDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./ChangeDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports